import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert"; // Importing MuiAlert for Snackbar
import { useStateContext } from "contexts/ContextProvider";

export default function AddSubdirectoryModal({
  loading,
  open,
  handleClose,
  parentDirectoryId, // Assuming these props are passed to the modal
  handleAddSubdirectory,
}) {
  const { auth } = useStateContext();
  const [subdirectoryName, setSubdirectoryName] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <>
        <Box
          sx={{
            p: 4,
            bgcolor: "white",
            borderRadius: 2,
            maxWidth: 400,
            width: "100%", // Responsive width
            boxShadow: 24, // Adds shadow
          }}
        >
          <Typography variant="h6" component="h2">
            Add Subdirectory
          </Typography>
          <TextField
            fullWidth
            label="Subdirectory Name"
            value={subdirectoryName}
            onChange={(e) => setSubdirectoryName(e.target.value)}
            margin="normal"
            error={!subdirectoryName.trim()}
            helperText={!subdirectoryName.trim() ? "Name is required." : ""}
          />
          <Button
            variant="contained"
            onClick={() =>
              handleAddSubdirectory({
                subDirName: subdirectoryName, // Field sent to backend
                parentDirectoryId, // Use the passed prop
                created_by: auth?.username, // Use the passed prop
              })
            }
            disabled={!subdirectoryName.trim()} // Disable button when input is empty
          >
            {loading ? <CircularProgress sx={{ color: "white" }} /> : "Add"}
          </Button>
        </Box>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <MuiAlert onClose={handleSnackbarClose} severity="error">
            Please enter a subdirectory name!
          </MuiAlert>
        </Snackbar>
      </>
    </Modal>
  );
}
